/**
 * "just now" / "5 minutes ago" / "1 hour ago" / "2 days ago".
 * Lifted from WorkspaceDataStoryCard so every "Last opened" style label shares
 * one implementation. Deliberately NOT dayjs .fromNow(): the design specifies
 * numeric forms ("1 hour ago"), while dayjs renders "an hour ago".
 */
export const formatRelativeTime = (iso: string): string => {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
};
